<template>
  <div>
    <app-banner v-if="isMain" :locale="$vuetify.lang.current" class="hidden-xs-only"></app-banner>
    <router-view></router-view>
  </div>
</template>

<script>
import AppBanner from "@/components/AppBanner";

export default {
  components: {
    appBanner: AppBanner,
  },
  data() {
    return {};
  },
  watch: {},
  computed: {
    currentFilter() {
      return this.$route.name;
    },
    isMain() {
      return this.currentFilter == "all";
    },
  },
  mounted() {
    console.log("mounted");
    let sheet = document.getElementById("scrolling_sheet");
    if (sheet) {
      let scrollY = this.$store.getters.getStoredPosition;
      sheet.scroll(0, scrollY);
      this.$store.commit("resetStoredPosition");
    }
  },

  beforeRouteLeave(to, from, next) {
    console.log("beforeRouteLeave");
    let sheet = document.getElementById("scrolling_sheet");
    this.$store.commit("saveStoredPosition", sheet.scrollTop);

    next();
  },
};
</script>


<style scoped>
</style>